import Big from 'big.js';

export class Decimal {
    public static ZERO: Decimal = new Decimal(0);

    private value: Big;

    constructor(n: Big | number | string) {
        const val = n instanceof Big ? n : new Big(n);
        this.value = val.round(2);
    }

    public static parse(n: string | number): Decimal {
        return new Decimal(typeof n === 'string' ? parseFloat(n) : n);
    }

    public plus(n: Decimal | number): Decimal {
        return new Decimal(this.value.plus(n instanceof Decimal ? n.value : n));
    }

    public minus(n: Decimal | number): Decimal {
        return new Decimal(this.value.minus(n instanceof Decimal ? n.value : n));
    }

    public times(n: Decimal | number): Decimal {
        return new Decimal(this.value.times(n instanceof Decimal ? n.value : n));
    }

    public abs(): Decimal {
        return new Decimal(this.value.abs());
    }

    public div(n: Decimal): number {
        return parseFloat(this.value.div(n.value).toString());
    }

    public divs(n: number): Decimal {
        return new Decimal(this.value.div(n));
    }

    public eq(n: Decimal | number): boolean {
        return this.value.eq(n instanceof Decimal ? n.value : n);
    }

    public appxEq(n: Decimal | number, tolerance: Decimal): boolean {
        return this.minus(n).abs().lte(tolerance);
    }

    public gt(n: Decimal | number): boolean {
        return this.value.gt(n instanceof Decimal ? n.value : n);
    }

    public gte(n: Decimal | number): boolean {
        return this.value.gte(n instanceof Decimal ? n.value : n);
    }

    public lt(n: Decimal | number): boolean {
        return this.value.lt(n instanceof Decimal ? n.value : n);
    }

    public lte(n: Decimal | number): boolean {
        return this.value.lte(n instanceof Decimal ? n.value : n);
    }

    public static min(a: Decimal, b: Decimal): Decimal {
        return a.lte(b) ? a : b;
    }

    public static max(a: Decimal, b: Decimal): Decimal {
        return a.gte(b) ? a : b;
    }

    public toFixed(dp = 2): string {
        return this.value.toFixed(dp);
    }

    public toString(): string {
        return this.value.toString();
    }

    public toSqlString(): number {
        return this.toNumber();
    }

    public toNumber(): number {
        return parseFloat(this.toString());
    }

    public toJSON(): number {
        return this.toNumber();
    }

    public valueOf(): string {
        return this.value.valueOf();
    }
}
